import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { CARDS } from '../shared/card';
import { SECTIONS } from '../shared/section';
import { ButtonLinkComponent } from '../shared/button/button-link/button-link.component';
import { LISTS } from '../shared/list';
import { OFFERS, formatChf } from '../shared/data/offers.data';

@Component({
  selector: 'lumiron-offer',
  templateUrl: './offer.component.html',
  styleUrl: './offer.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, SECTIONS, CARDS, ButtonLinkComponent, LISTS],
})
export class OfferComponent {
  // eslint-disable-next-line unicorn/consistent-function-scoping
  protected readonly adultOffers = OFFERS.filter(o => o.id !== 'kids');
  // eslint-disable-next-line unicorn/consistent-function-scoping
  protected readonly kidsOffers = OFFERS.filter(o => o.id === 'kids');
  protected readonly formatChf = formatChf;
}
